module.exports = __webpack_public_path__ + "img/padlock.de00e7c8.svg";